import postFeaturedSection from './post/postFeaturedSection';

export default function postFeatured() {
    const sections = document.querySelectorAll('[data-post-featured]');
    sections.forEach(item => new postFeaturedSection(item));
}
